export const dimConf = {
    data: {
        id: 'data',
        value: 'data',
        param: 'dx',
        dimensionName: 'dx',
        objectName: 'dx',
    },
    category: {
        name: 'categories',
        dimensionName: 'co',
        objectName: 'co',
    },
    indicator: {
        id: 'indicator',
        value: 'indicators',
        param: 'in',
        dimensionName: 'dx',
        objectName: 'in',
        itemType: 'INDICATOR',
    },
    dataElement: {
        id: 'dataElement',
        value: 'dataElement',
        param: 'de',
        dimensionName: 'dx',
        objectName: 'de',
        itemType: 'DATA_ELEMENT', // AGGREGATE_DATA_ELEMENT
    },
    operand: {
        id: 'operand',
        value: 'operand',
        param: 'dc',
        dimensionName: 'dx',
        objectName: 'dc',
        itemType: 'DATA_ELEMENT_OPERAND',
    },
    dataSet: {
        value: 'dataSets',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'DATA_SET',
    },
    eventDataItem: {
        value: 'eventDataItem',
        dimensionName: 'dx',
        objectName: 'di',
    },
    programDataElement: {
        value: 'programDataElement',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_DATA_ELEMENT',
    },
    programAttribute: {
        value: 'programAttribute',
        dimensionName: 'dx',
        objectName: 'di',
        itemType: 'PROGRAM_ATTRIBUTE',
    },
    programIndicator: {
        value: 'programIndicator',
        dimensionName: 'dx',
        objectName: 'pi',
        itemType: 'PROGRAM_INDICATOR',
    },
    period: {
        id: 'period',
        value: 'period',
        param: 'pe',
        dimensionName: 'pe',
        objectName: 'pe',
    },
    organisationUnit: {
        id: 'organisationUnit',
        value: 'organisationUnit',
        param: 'ou',
        dimensionName: 'ou',
        objectName: 'ou',
    },
    reportingRate: {
        value: 'reportingRate',
        dimensionName: 'dx',
        objectName: 'ds',
        itemType: 'REPORTING_RATE',
    },
    value: {
        id: 'value',
        value: 'value',
        param: 'value',
        dimensionName: 'value',
        objectName: 'value',
    },
};



// WEBPACK FOOTER //
// ./src/constants/dimension.js